import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useState, useEffect, useCallback } from 'react';
import styles from './TicketFields.module.scss';
import { Select, Input, DatePicker } from 'antd';
import LookupHelper from '../LookupHelper';
import moment from 'moment';
import { capitalizeFirstLetter } from '../../utils/helper';
import { searchUsersApi } from '../../api/Header';
import { isEmpty } from 'lodash';
import Loader from '../Loader';
const {
  Option
} = Select;
const {
  TextArea
} = Input;
const RenderType = _ref => {
  let {
    item = {},
    setFormData,
    url
  } = _ref;
  const {
    type,
    id,
    label,
    isLookup,
    value,
    parentValue,
    parents,
    options,
    filteredOptions = []
  } = item;
  let renderOptions;
  if (filteredOptions.length > 0) {
    renderOptions = filteredOptions;
  } else {
    renderOptions = options;
  }
  let finalOptions;
  if (parentValue) {
    finalOptions = renderOptions.map(obj => {
      let name = obj.name;
      let val = obj.value;
      if (!obj.isFiltered) {
        const capitalizedParentValue = capitalizeFirstLetter(parentValue);
        name = name.replace(new RegExp("^".concat(capitalizedParentValue, "::")), "");
      }
      return _objectSpread(_objectSpread({}, obj), {}, {
        name,
        value: val
      });
    });
  } else {
    finalOptions = renderOptions;
  }
  const handleChange = (data, dateString) => {
    setFormData(prevData => prevData.map(item => item.id === id ? _objectSpread(_objectSpread({}, item), {}, {
      value: ['date', 'datetime', 'relative_date'].includes(type) ? moment(dateString).valueOf() : data
    }) : item));
  };
  if (isLookup) return /*#__PURE__*/React.createElement(LookupHelper, {
    className: styles.value,
    onChange: val => handleChange(val),
    apiCall: searchUsersApi,
    placeholder: 'Start tying to search',
    defaultValue: value,
    responseKey: 'users',
    labelKey: 'name',
    valueKey: 'email'
  });
  if (['dropdown', 'multiselect'].includes(type)) return /*#__PURE__*/React.createElement(Select, {
    mode: type === 'multiselect' ? 'multiple' : 'default',
    className: styles.value,
    placeholder: "Please select ".concat(label),
    onChange: handleChange,
    defaultValue: value,
    value: value,
    allowClear: parents ? false : true
  }, finalOptions.map(item => /*#__PURE__*/React.createElement(Option, {
    key: item.id,
    value: item.value
  }, item.name)));
  if (['date', 'datetime', 'relative_date'].includes(type)) return /*#__PURE__*/React.createElement(DatePicker, {
    format: type === 'datetime' ? 'MM/DD/YYYY h:mm' : 'MM/DD/YYYY',
    showTime: type === 'datetime' ? true : false,
    className: styles.value,
    defaultValue: value ? moment(value) : undefined,
    onChange: handleChange
  });
  if (type === 'textarea') return /*#__PURE__*/React.createElement(TextArea, {
    placeholder: "Please enter ".concat(label),
    defaultValue: value,
    onChange: e => handleChange(e.target.value),
    className: styles.value,
    rows: "4"
  });else return /*#__PURE__*/React.createElement(Input, {
    placeholder: "Please enter ".concat(label),
    onChange: e => handleChange(e.target.value),
    defaultValue: value,
    className: styles.value,
    type: type
  });
};
function TicketFields(_ref2) {
  let {
    name,
    fieldsData = {},
    getTicketFields,
    url,
    isLoading
  } = _ref2;
  const {
    associated_fields_values,
    form
  } = fieldsData;
  const {
    evaluate,
    associated_fields
  } = form;
  const fields = associated_fields_values.sort((a, b) => associated_fields.indexOf(a.id) - associated_fields.indexOf(b.id));
  const [formData, setFormData] = useState([]);
  const [showFields, setShowFields] = useState(true);
  const generateFormData = fields => {
    const data = [];
    fields.map(item => data.push({
      id: item === null || item === void 0 ? void 0 : item.id,
      value: item === null || item === void 0 ? void 0 : item.value,
      type: item === null || item === void 0 ? void 0 : item.type,
      options: item === null || item === void 0 ? void 0 : item.options,
      label: item === null || item === void 0 ? void 0 : item.title,
      isLookup: item === null || item === void 0 ? void 0 : item.lookup_users,
      show: true
    }));
    return data;
  };
  useEffect(() => {
    setFormData(generateFormData(fields));
  }, [fields]);
  useEffect(() => {
    getTicketFields(formData);
  }, [formData, getTicketFields]);
  const renderConditions = useCallback(item => {
    const {
      parent_conditions,
      child,
      type
    } = item;
    child.forEach(obj => {
      const currentChild = formData.find(item => item.id === obj.field_id);
      if (currentChild) {
        currentChild.show = false;
        currentChild.parents = parent_conditions.map(obj => obj.field_id);
      }
    });
    const hasValidParent = parent_conditions.every(obj => {
      var _currentObj$value2;
      const currentObj = formData.find(item => item.id === obj.field_id);
      if (!currentObj) return false;
      let currentObjIds;
      if (['dropdown', 'multiselect'].includes(currentObj.type)) {
        var _currentObj$options$f2, _obj$values;
        if (Array.isArray(currentObj.value)) currentObjIds = currentObj.value.map(obj => {
          var _currentObj$options$f;
          return (_currentObj$options$f = currentObj.options.find(item => item.value === obj)) === null || _currentObj$options$f === void 0 ? void 0 : _currentObj$options$f.id;
        });else currentObjIds = (_currentObj$options$f2 = currentObj.options.find(item => item.value === currentObj.value)) === null || _currentObj$options$f2 === void 0 ? void 0 : _currentObj$options$f2.id;
        return obj === null || obj === void 0 || (_obj$values = obj.values) === null || _obj$values === void 0 ? void 0 : _obj$values.every(val => {
          var _currentObjIds;
          return (_currentObjIds = currentObjIds) === null || _currentObjIds === void 0 ? void 0 : _currentObjIds.includes(val);
        });
      }
      if (['date', 'datetime'].includes(currentObj.type)) {
        var _obj$values2, _currentObj$value;
        if ((_obj$values2 = obj.values) !== null && _obj$values2 !== void 0 && _obj$values2.includes((_currentObj$value = currentObj.value) === null || _currentObj$value === void 0 ? void 0 : _currentObj$value.toString())) {
          return true;
        }
      }
      if (((_currentObj$value2 = currentObj.value) === null || _currentObj$value2 === void 0 ? void 0 : _currentObj$value2.length) > 0 && obj.values.includes("{{not_empty}}")) return true;
      if (isEmpty(currentObj.value) && obj.values.includes("{{empty}}")) return true;
      return false;
    });
    if (hasValidParent) {
      child.forEach(obj => {
        const currentChild = formData.find(item => item.id === obj.field_id);
        if (currentChild) {
          if (type === 'show') {
            currentChild.show = true;
          } else if (type === 'filter') {
            const currentChildParent = formData.find(i => i.id === currentChild.parents[0]);
            const currentChildParentValue = currentChildParent ? currentChildParent.value : undefined;
            if (currentChild.parentValue !== currentChildParentValue) {
              currentChild.value = undefined;
            }
            const filteredOptions = currentChild.options.filter(opt => opt.value.startsWith("".concat(currentChildParentValue, "__")));
            currentChild.filteredOptions = filteredOptions;
            currentChild.parentValue = currentChildParentValue;
            currentChild.show = true;
          }
          if (Array.isArray(obj === null || obj === void 0 ? void 0 : obj.default) && (!Array.isArray(currentChild === null || currentChild === void 0 ? void 0 : currentChild.value) || currentChild.value.length === 0) && obj.default.length > 0) {
            if (['dropdown', 'multiselect'].includes(currentChild.type)) {
              currentChild.value = obj.default.map(d => (currentChild.options.find(o => o.id === d) || {}).value);
            } else if (['date', 'datetime'].includes(currentChild.type)) {
              currentChild.value = moment(parseInt(obj.default[0]));
            } else {
              currentChild.value = obj.default[0];
            }
            currentChild.show = true;
          }
        }
      });
    }
  }, [formData]);
  useEffect(() => {
    evaluate.map(item => renderConditions(item));
  }, [evaluate, renderConditions]);
  const handleShowFields = () => {
    setShowFields(prev => !prev);
  };
  const renderTicketFields = () => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, name ? /*#__PURE__*/React.createElement("div", {
      className: styles.heading,
      onClick: handleShowFields
    }, /*#__PURE__*/React.createElement("span", null, name), /*#__PURE__*/React.createElement("span", {
      onClick: handleShowFields,
      className: showFields ? 'icon-chevron-up' : 'icon-chevron-down'
    })) : '', /*#__PURE__*/React.createElement("div", {
      className: styles.items
    }, evaluate.map(item => renderConditions(item)), Array.isArray(formData) && showFields && /*#__PURE__*/React.createElement(React.Fragment, null, formData.map(item => item.show && /*#__PURE__*/React.createElement("div", {
      key: item.id,
      className: styles.item
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.label
    }, item.label), /*#__PURE__*/React.createElement(RenderType, {
      item: item,
      setFormData: setFormData,
      url: url
    }))))));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, isLoading ? /*#__PURE__*/React.createElement(Loader, {
    className: styles.loader
  }) : renderTicketFields());
}
export default TicketFields;